import { useCallback, useRef, useState } from 'react';
import { reachGoal } from './leadMagnetContent';

// ----------------------------------------------------------------------------
// Общая логика открытия/закрытия модального окна лид-магнита.
// Возвращает ref на кнопку-триггер, чтобы вернуть ей фокус после закрытия.
// ----------------------------------------------------------------------------
export function useLeadMagnetModal() {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const openModal = useCallback(() => {
    reachGoal('leadmagnet_open');
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
    window.setTimeout(() => triggerRef.current?.focus(), 0);
  }, []);

  return { open, openModal, closeModal, triggerRef };
}